import ajax from '@/utils/request'

// 企业模板统计
export const queryTemplateSummary = () => ajax('/api/template/summary/', '', 'GET')
// 列表
export const queryTemplate = data => ajax('/api/template/list/', data, 'POST')
// 删除
export const deleteTemplate = data => ajax(`/api/template/delete/${data}`, null, 'POST')
// 详情
export const templateDetail = data => ajax('/api/template/get/', data, 'GET')
// 获取机构模版
export const getOrgTemplate = data => ajax('/api/template/org/', data, 'GET')
// 获取设备模版
export const getDeviceTemplate = data => ajax('/api/template/device/', data, 'GET')
// 获取模板类型
export const queryPushTemplate = data => ajax('/api/template/get/pushTemplate/', data, 'GET')
// 添加模版
export const addTemplate = data => ajax('/api/template/add', data, 'POST')
// 更新并审核模版
export const updateTemplate = data => ajax('/api/template/update/', data, 'POST')
// 查询打印模板列表
export const printerTemplateList = data => ajax('/api/template/get/printer/list', data, 'POST')
// 添加打印模板
export const addPrinterTemplate = data => ajax('/api/template/add/printer/template', data, 'POST')
// 编辑打印模板
export const updatePrinterTemplate = data => ajax('/api/template/update/printer/template', data, 'POST')
// 获取Logo列表
export const logoList = data => ajax('/api/template/get/printer/logo/list', data, 'GET')
// 添加打印Logo
export const addPrinterLogo = data => ajax('/api/template/add/printer/logo', data, 'POST')
